export default __webpack_public_path__ + "static/media/channel-up.c5c5b146.png";